var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFishingFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.5,115.3c-35.7-23.1-195.2-65.1-340-18.9C28.3,136.3-1.1,232.8,7.3,293.7c8.4,56.7,25.2,90.2,27.3,94.4l0,0 c8.4,39.9,67.2,79.8,88.2,94.4c4.2,4.2,10.5,0,10.5-4.2c0-10.5,0-29.4,4.2-52.5c4.2-25.2,18.9-44.1,29.4-54.6 c4.2-4.2,0-8.4-4.2-8.4c-23.1,2.1-60.9,4.2-79.8-8.4c-75.6-35.7-33.6-77.7-23.1-86.1c4.2-4.2,8.4-4.2,12.6-6.3 c54.6-18.9,111.2-10.5,203.6-27.3c2.1,25.2,14.7,63,33.6,52.5c14.7-8.4,27.3-44.1,37.8-67.2c8.4-2.1,18.9-6.3,27.3-8.4 c8.4-2.1,21-6.3,33.6-12.6c12.6-4.2,71.4-35.7,96.5-67.2C506.8,127.9,506.8,119.5,500.5,115.3z M412.3,127.9 c-4.2,0-8.4-4.2-8.4-8.4c0-4.2,4.2-8.4,8.4-8.4c4.2,0,8.4,4.2,8.4,8.4C420.7,123.7,416.5,127.9,412.3,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1,310.5c-16.8,10.5-16.8,14.7-31.5,0c-12.6-16.8-21-29.4-12.6-37.8c12.6-8.4,54.6-14.7,79.8-12.6 C147.9,260.1,126.9,297.9,110.1,310.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,102.8c-14.7,4.2-48.3-10.5-35.7-21c10.5-10.5,23.1-31.5,35.7-50.4c12.6-18.9,111.2,42,111.2,42s-29.4,4.2-58.8,10.5 C150,90.2,126.9,98.6,120.6,102.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFishingFish);
export default __webpack_public_path__ + "static/media/icon-fishing-fish.130dd00bafc92cb2c2441396a0b12035.svg";
export { ForwardRef as ReactComponent };